import { render, staticRenderFns } from "./SeoKeywordDensityContent.vue?vue&type=template&id=a288a9cc"
import script from "./SeoKeywordDensityContent.vue?vue&type=script&lang=js"
export * from "./SeoKeywordDensityContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports